import { LoggerHelper } from '@bcp-channels-sharedcomponents-reactjs/core/dist/helpers';
import { BaseStateSessionInfo } from '@store';

const SESSION_STORAGE_PREFIX = '__session_storage_IziBizi_';
type SessionStorageKeys = 'contextId' | 'ott' | 'tokenOAuth' | 'authorizationCode' | 'state' | 'plan' | 'processId';

export const getSessionInfo = (encodedSessionInfo?: string): BaseStateSessionInfo => {
	LoggerHelper.log('SessionInfo', 'getSessionInfo > encodedSessionInfo', encodedSessionInfo);

	const decodedSessionInfo = encodedSessionInfo ? decodeURI(encodedSessionInfo) : null;

	LoggerHelper.log('SessionInfo', 'getSessionInfo > decodedSessionInfo', decodedSessionInfo);

	return decodedSessionInfo ? JSON.parse(decodedSessionInfo) : null;
};

export const getSessionStorage = <TOutput>(key: SessionStorageKeys): TOutput | undefined => {
	try {
		const savedValue = sessionStorage.getItem(`${SESSION_STORAGE_PREFIX}${key}`);

		return savedValue ? JSON.parse(savedValue) : undefined;
	} catch (err) {
		return undefined;
	}
};

export const saveSessionStorage = <TInput>(key: SessionStorageKeys, value: TInput): void => {
	try {
		sessionStorage.setItem(`${SESSION_STORAGE_PREFIX}${key}`, JSON.stringify(value));
	} catch (err) {}
};
